/**
 * navigation/appStack.tsx
 * SK Hire content as a native-stack. Lateral sidebar navigation → animation
 * disabled for an instant view-swap. The persistent shell (sidebar) lives in
 * appShell.tsx around this navigator.
 *
 * Sections mirror the design reference. Screens are rebuilt to spec one at a
 * time; not-yet-rebuilt sections render the RebuildingScreen placeholder so the
 * app stays runnable for fidelity review.
 */

import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import type { AppStackParamList } from './types';

import DashboardScreen from '../screens/dashboard/dashboard';
import JobsScreen from '../screens/jobs/jobs';
import JobDetailScreen from '../screens/jobs/jobDetail';
import JobTokenHistoryScreen from '../screens/jobs/jobTokenHistory';
import CandidatesScreen from '../screens/candidates/candidatesList';
import CandidateDetailScreen from '../screens/candidates/candidateProfile';
import RunScreen from '../screens/run/matchRun';
import IntegrationsScreen from '../screens/integrations/integrations';
import ComplianceScreen from '../screens/compliance/compliance';
import OpsConsoleScreen from '../screens/ops/opsConsole';
import AiUsageScreen from '../screens/aiUsage/aiUsage';
// (all sections now have real screens; the _Rebuilding placeholder is retired)

const Stack = createNativeStackNavigator<AppStackParamList>();

export default function AppStack() {
  return (
    <Stack.Navigator
      initialRouteName="dashboard"
      screenOptions={{ headerShown: false, animation: 'none' }}
    >
      <Stack.Screen name="dashboard" component={DashboardScreen} />
      <Stack.Screen name="jobs" component={JobsScreen} />
      <Stack.Screen name="jobDetail" component={JobDetailScreen} />
      <Stack.Screen name="jobTokenHistory" component={JobTokenHistoryScreen} />
      <Stack.Screen name="run" component={RunScreen} />
      <Stack.Screen name="candidates" component={CandidatesScreen} />
      <Stack.Screen name="candidateDetail" component={CandidateDetailScreen} />
      <Stack.Screen name="integrations" component={IntegrationsScreen} />
      <Stack.Screen name="compliance" component={ComplianceScreen} />
      <Stack.Screen name="ops" component={OpsConsoleScreen} />
      <Stack.Screen name="aiUsage" component={AiUsageScreen} />
    </Stack.Navigator>
  );
}
